const Link = ({ className, fillColor = '#008600' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6551 2.35317C15.7264 0.424501 12.6079 0.397401 10.646 2.29226L9.20405 3.7257L9.13449 3.804C8.87935 4.13017 8.90108 4.60293 9.20061 4.9042C9.5251 5.23059 10.0527 5.23213 10.3791 4.90764L11.8125 3.48264L11.9496 3.35737C13.2542 2.23059 15.2351 2.29024 16.4766 3.53168C17.7624 4.81746 17.7804 6.89648 16.5172 8.20441L14.0273 10.6941L13.8871 10.8265C13.2171 11.4234 12.332 11.7269 11.4317 11.6624C10.467 11.5933 9.57986 11.1086 9.00055 10.3342C8.72488 9.96564 8.20264 9.89036 7.8341 10.166C7.46556 10.4417 7.39027 10.9639 7.66594 11.3325C8.5349 12.4942 9.86557 13.2212 11.3126 13.3248C12.7596 13.4285 14.1803 12.8985 15.2059 11.8725L17.7058 9.37259L17.8522 9.21455C19.6081 7.23706 19.533 4.23108 17.6551 2.35317ZM12.3339 8.66752C11.4649 7.50583 10.1343 6.77882 8.68724 6.67519L8.45903 6.66407C7.09176 6.62871 5.76554 7.15552 4.79389 8.12752L2.29399 10.6274L2.14761 10.7855C0.391723 12.7629 0.466834 15.7689 2.34475 17.6468C4.27342 19.5755 7.39195 19.6026 9.35384 17.7077L10.7892 16.2726L10.8585 16.1941C11.1127 15.8672 11.0896 15.3945 10.7892 15.0941C10.4637 14.7686 9.9361 14.7686 9.61066 15.0941L8.18566 16.5191L8.0487 16.6442C6.74562 17.7694 4.7647 17.7098 3.52326 16.4683C2.23748 15.1825 2.21941 13.1035 3.48266 11.7956L5.9725 9.30593L6.11271 9.17354C6.78273 8.57658 7.66781 8.27311 8.56818 8.3376C9.53286 8.40668 10.42 8.89136 10.9993 9.66582C11.275 10.0344 11.7972 10.1096 12.1657 9.83397C12.5343 9.5583 12.6096 9.03606 12.3339 8.66752Z"
        fill={fillColor}
      />
    </svg>
  );
};

Link.propTypes = {
  className: PropTypes.string,
  fillColor: PropTypes.string,
};

export default Link;
